import { Fragment, useEffect, useRef, useState } from "react";
import $ from "jquery";
import { RequestMailDownloadForm } from "./requestMailDownloadForm";
import { DownloadTitleContainer } from "./downloadTitleContainer";
import { DownloadMailSuccess } from "./downloadMailSuccess";
import { DownloadFileList } from "./downloadFileList";
import { MailContainerSubTitle, NoDownloadFileContainer } from "./noDownaloadFileContainer";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { pdfSendMailtoggleSections, toggleSections } from "../scripts";
import { isValidArray } from "../../../Layout/Common/common";
import { SuccessMessageContainer } from "../../../Layout/Common/alert/SuccessMessageContainer";
import { useProductOverlay } from "../productOverlay/productOverlayContext";

export const HybridDownloadContainer = ({ params }) => {
  const [familyData, setFamilyData] = useState(null);
  const [attachements, setAttachements] = useState(null);
  const [downloadMailSend, setDownloadMailSend] = useState(false);
  const { getAttachments, sendMailAttachments } = useGlobalFunction();
  const overlay = useProductOverlay();
  const toastMessageRef = useRef(null);
  useEffect(() => {
    setFamilyData(params);
    GetFiles(params);
  }, [params]);

  const GetFiles = async (params) => {
    let results = null;

    if (params.isFamily === false && params.productId) results = await getAttachments(params.productId, "product");
    else results = await getAttachments(params.familyId, "family");

    if (results && isValidArray(results)) {
      setAttachements(results);
      $("#requestDownloads").slideUp("slow");
      $("#listofProduct").slideDown("slow");
    } else {
      setAttachements(null);
      $("#requestDownloads").slideDown("slow");
      $("#listofProduct").slideUp("slow");
    }
  };

  const handleSendRequest = async ({ fullName, phone, queries }) => {
    try {
      var payload = {
        fileName: familyData.familyName,
        fullName: fullName.trim(),
        phone: phone,
        message: queries,
        url: overlay?.productUrl ?? window.location.href,
      };
      let results = await sendMailAttachments(payload);
      if (results) {
        toastMessageRef.current.showAlert(
          "Success!",
          "Thanks for your download enquiry. Our Customer Sales Team will be in contact with you Shortly.",
        );
      }
      $("#requestDownloads").slideUp("slow");
      $("#listofProduct").slideDown("slow");
      return true;
    } catch (ex) {
      console.error("handleSendRequest", ex);
      return false;
    }
  };

  const requestDownClick = () => {
    $("#requestDownloads").slideToggle("slow");
    $("#listofProduct").slideToggle("slow");
  };

  return (
    <Fragment>
      {familyData && (
        <div className="mb-20px" id="section-downloads">
          <div className="proSection-title custom-border">
            <h4
              className="d-flex align-items-start justify-content-between"
              data-bs-toggle="collapse"
              data-bs-target="#downloads-container"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              Downloads <i className="fa-solid fa-chevron-down" />
            </h4>
          </div>
          <div className="collapse" id="downloads-container">
            <SuccessMessageContainer ref={toastMessageRef} />
            {!isValidArray(attachements) && <NoDownloadFileContainer familyName={familyData.familyName} />}
            <div className="row collapse" id="listofProduct">
              {isValidArray(attachements) && <DownloadFileList params={attachements} />}
              <div className="col-lg-12">
                <div className="request-download-file  product-button">
                  <button
                    type="submit"
                    className="btn btn-products btn-unavailable"
                    id="reqDownloads"
                    onClick={requestDownClick}
                  >
                    Request Download File
                  </button>
                </div>
              </div>
            </div>
            <div className="row proNo-downloads" id="requestDownloads">
              <div className="col-lg-12">
                {/* Inner Title */}
                {isValidArray(attachements) && (
                  <div className="question-innerTitle">
                    <MailContainerSubTitle />
                  </div>
                )}
              </div>
              <RequestMailDownloadForm
                onSubmit={handleSendRequest}
                hasAttachment={isValidArray(attachements) ? true : false}
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
